// Helper function to build a query string from an object, excluding undefined, null, empty strings, and 'undefined' strings
export const buildQueryString = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value !== 'undefined') {
      query.append(key, value);
    }
  });
  return query.toString();
};
